import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/mockup-1.png'
import _imports_1 from '@/assets/icon.svg'


const _hoisted_1 = {
  class: "mockup xyz-in",
  xyz: "fade duration-6 delay-2"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"mockup-bg\"><svg id=\"a\" class=\"text-blue\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1170 2532\"><rect width=\"1170\" height=\"2532\" rx=\"141.28\" ry=\"141.28\" style=\"stroke-width:0px;\"></rect></svg><svg id=\"b\" class=\"text-teal\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1170 2532\"><rect width=\"1170\" height=\"2532\" rx=\"141.28\" ry=\"141.28\" style=\"stroke-width:0px;\"></rect></svg></div>", 1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Locate any phone, anywhere",
  class: "xyz-in",
  xyz: "left fade duration-6 delay-3",
  style: {"--xyz-translate-x":"30%"}
}, null, -1)
const _hoisted_4 = {
  class: "alert xyz-nested xyz-in",
  xyz: "fade down small-5 delay-9 duration-4 ease-out-back"
}
const _hoisted_5 = { class: "text-blue mb-05" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Foundit"
}, null, -1)
const _hoisted_7 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h6", _hoisted_5, [
        _hoisted_6,
        _createTextVNode(" " + _toDisplayString($setup.strings.home.main[18]), 1)
      ]),
      _createElementVNode("p", _hoisted_7, _toDisplayString($setup.strings.home.main[20]), 1)
    ])
  ]))
}